import { syncAction } from 'lib/action';

export const socketMessageReceivedUnhandledAction = syncAction('WS/UNHANDLED_MESSAGE_RECEIVED_ACTION');
export const socketMessageUserStartedViewingDocumentAction = syncAction('WS/USER_VIEWING_DOCUMENT');
export const socketMessageUserFinishedViewingDocumentAction = syncAction('WS/USER_FINISHED_VIEWING_DOCUMENT');
export const socketMessageUsersViewingDocumentAction = syncAction('WS/USERS_VIEWING_DOCUMENT');
export const resetUsersViewingDocumentAction = syncAction('WS/RESET_USERS_VIEWING_DOCUMENT');
export const documentForceSyncErpCompletedAction = syncAction('WS/DOCUMENT_FORCE_SYNC_ERP_COMPLETED');
export const documentPublishCompletedAction = syncAction('WS/DOCUMENT_PUBLISH_COMPLETED');
